<form *ngIf="specialDeviceFG" [formGroup]="specialDeviceFG" class="component-container special-consumer-container">
  <div class="ui-g">
    <div class="ui-g-12 ui-xl-12 ui-lg-12 ui-md-12 ui-sm-12 ui-xs-12 top-border mb-12 mt-10">
      <div class="ui-g-6 ui-xl-6 ui-lg-6 ui-md-6 ui-sm-6 ui-xs-6 field-rows">
        <label class="ui-g-3 field-label text-right-align required" for="device">
          {{ 'technician-data.form-fields.device' | translate }}
        </label>
        <p-dropdown
          (onChange)="selectSpecialDevice($event)"
          [options]="specialDevices"
          formControlName="device"
          [readonly]="isReadOnly"
          id="device"
          placeholder="-Select-">
          <ng-template let-item pTemplate="selectedItem">
            <span class="drop-item-label">{{ 'lookup.' + specialDeviceKey + '.options.' + item['value'] + '.name' | translate }}</span>
          </ng-template>
          <ng-template let-option pTemplate="item">
            <div class="drop-item">
              <span class="drop-item-label">{{ 'lookup.' + specialDeviceKey + '.options.' + option['value'] + '.name' | translate }}</span>
            </div>
          </ng-template>
        </p-dropdown>
      </div>

      <div class="ui-g-6 ui-xl-6 ui-lg-6 ui-md-6 ui-sm-6 ui-xs-6 field-rows" *ngIf="specialDeviceType === 'other'">
        <label for="power-connection-other-type required" class="ui-g-3"></label>
        <input
          id="power-connection-other-type"
          class="ui-input pInputText"
          formControlName="otherType"
          pInputText
          type="text"
          [readonly]="isReadOnly" />
      </div>

      <div (click)="removeElement()" *ngIf="!isReadOnly" class="delete-consumer-btn pi pi-trash pointer-cursor text-right-align"></div>
    </div>

    <div class="ui-g-12 ui-xl-12 ui-lg-12 ui-md-12 ui-sm-12 ui-xs-12">
      <div class="ui-g-6 ui-xl-6 ui-lg-6 ui-md-6 ui-sm-6 ui-xs-6 field-rows">
        <label class="ui-g-3 field-label text-right-align required" for="power-connection-count">
          {{ 'technician-data.form-fields.count' | translate }}
        </label>
        <input
          [appNumber]="true"
          class="ui-input pInputText small-width"
          formControlName="count"
          id="power-connection-count"
          maxlength="5"
          pInputText
          size="30"
          [readonly]="isReadOnly" />
      </div>

      <div class="ui-g-6 ui-xl-6 ui-lg-6 ui-md-6 ui-sm-6 ui-xs-6 field-rows">
        <label class="ui-g-3 field-label text-right-align required" for="power-connection-power">
          {{ 'technician-data.form-fields.power' | translate }}
        </label>
        <input
          appFloatNumber="2"
          class="ui-input pInputText small-width"
          formControlName="power"
          id="power-connection-power"
          maxlength="5"
          pInputText
          size="30"
          [readonly]="isReadOnly" />
        <span class="field-unit-label">{{ unitLabels.power }}</span>
      </div>
    </div>

    <div class="ui-g-12 ui-xl-12 ui-lg-12 ui-md-12 ui-sm-12 ui-xs-12 mt-10">
      <div
        *ngIf="currentInstallationFlow !== installationFlowType.TemporaryConnection"
        class="ui-g-6 ui-xl-6 ui-lg-6 ui-md-6 ui-sm-6 ui-xs-6 field-rows">
        <label class="ui-g-3 field-label text-right-align" for="power-connection-description">
          {{ 'technician-data.form-fields.description' | translate }}
        </label>
        <input
          class="ui-input pInputText"
          formControlName="description"
          id="power-connection-description"
          pInputText
          size="30"
          type="text"
          [readonly]="isReadOnly" />
      </div>
    </div>

    <div *ngIf="currentInstallationFlow !== installationFlowType.TemporaryConnection" class="ui-g-12">
      <div class="ui-g-12 ui-xl-12 ui-lg-12 ui-md-12 ui-sm-12 ui-xs-12 mt-10">
        <div class="ui-g-4 field-rows">
          <label class="margin-right-align required">{{ 'technician-data.form-fields.controllable-facility' | translate }}</label>
        </div>
        <div class="ui-g-2 field-rows">
          <p-radioButton
            formControlName="is_controllable_facility"
            name="controllable-facility"
            [value]="true"
            [label]="'grid-comp.yes' | translate"></p-radioButton>
        </div>
        <div class="ui-g-2 field-rows">
          <p-radioButton
            formControlName="is_controllable_facility"
            name="controllable-facility"
            [value]="false"
            [label]="'grid-comp.no' | translate"></p-radioButton>
        </div>
      </div>
      <div class="ui-g-12 ui-xl-12 ui-lg-12 ui-md-12 ui-sm-12 ui-xs-12 mt-10">
        <div class="ui-g-4 field-rows">
          <label class="margin-right-align required">{{ 'technician-data.form-fields.public-device' | translate }}</label>
        </div>
        <div class="ui-g-2 field-rows">
          <p-radioButton
            formControlName="is_public_facility"
            name="public-facility"
            [value]="true"
            [label]="'grid-comp.yes' | translate"></p-radioButton>
        </div>
        <div class="ui-g-2 field-rows">
          <p-radioButton
            formControlName="is_public_facility"
            name="public-facility"
            [value]="false"
            [label]="'grid-comp.no' | translate"></p-radioButton>
        </div>
      </div>
      <div *ngIf="specialDeviceFG.controls.module_type" class="ui-g-12 ui-xl-12 ui-lg-12 ui-md-12 ui-sm-12 ui-xs-12 mt-10">
        <div class="ui-g-4 field-rows">
          <label class="margin-right-align" [class.required]="specialApplianceTypeNotOther">
            {{ 'technician-data.form-fields.module' | translate }}
          </label>
        </div>
        <div class="ui-g-2 field-rows">
          <p-radioButton
            name="module-type"
            value="module1"
            label="{{ 'technician-data.form-fields.module1' | translate }}"
            formControlName="module_type"></p-radioButton>
        </div>
        <div class="ui-g-2 field-rows">
          <p-radioButton
            name="module-type"
            value="module2"
            label="{{ 'technician-data.form-fields.module2' | translate }}"
            formControlName="module_type"></p-radioButton>
        </div>
        <div class="ui-g-2 field-rows">
          <p-radioButton
            name="module-type"
            value="module3"
            label="{{ 'technician-data.form-fields.module3' | translate }}"
            formControlName="module_type"></p-radioButton>
        </div>
      </div>
      <div *ngIf="specialDeviceFG.controls.zerez_id">
        <div class="ui-g-12">
          <label class="field-label" [class.required]="specialApplianceTypeNotOther" for="zerez_id">
            {{ 'facilities-data.form-fields.zerez-id' | translate }}
          </label>
          <p-inputMask
            class="ui-input pInputText"
            id="zerez_id"
            formControlName="zerez_id"
            [autoClear]="false"
            [mask]="zerezIdMask.mask"
            [characterPattern]="zerezIdMask.charPattern"
            type="text"></p-inputMask>
          <button
            pButton
            type="button"
            style="margin: 1rem"
            [label]="isLoading ? ('technical-data.validating' | translate) : ('technical-data.check-id' | translate)"
            [icon]="isLoading ? 'pi pi-spin pi-spinner' : ' '"
            [disabled]="isReadOnly || isLoading || !specialDeviceFG.get('zerez_id').valid"
            (click)="validateZerezId()"></button>
        </div>
        <span class="unit-margin" innerHTML="{{ 'facilities-data.form-fields.zerez-id-info' | translate }}"></span>
      </div>
    </div>
  </div>
</form>
